module.exports = __webpack_public_path__ + "static/media/parayas.43851e1e.png";